import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { getPaymentDeductionStatus } from 'Utils/getPaymentStatus';

interface IStatus {
  statusCode: number;
}

export const Status = ({ statusCode }: IStatus) => {
  const status = getPaymentDeductionStatus(
    statusCode,
    Dictionary[DICTIONARY.PaymentsDeductions].paymentDeductionCard.statusCode
  );

  return (
    <Box
      sx={{
        ...status.style,
        borderRadius: '6px',
        textAlign: 'center',
        padding: '0 12px 4px',
        width: 'fit-content',
      }}
    >
      <Typography variant={'body5'}>{status.text}</Typography>
    </Box>
  );
};
